// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__rJEyb","amount":"Amount_amount__3Q2BG","tip":"Amount_tip__3NqNA","tipHeader":"Amount_tipHeader__3N2ML","tipsWrap":"Amount_tipsWrap__32af0"};